import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import { post } from "../config/axiosConfig.ts";
import { ITicketsResponse } from "../model.ts";
import { BaseUrl } from "../const.ts";

export const useCheckTickets = () => {
  const [loading, setLoading] = useState(false);
  const [orderConfirmed, setOrderConfirmed] =
    useState<ITicketsResponse | null>();
  const toast = useToast();

  const onSubmit = async (data) => {
    const arr: any = [];
    data.eventTicketInfo.map((item) =>
      item.ticketInfo.map((it) => {
        if (it.quantity > 0) {
          arr.push(it);
        }
      })
    );

    data.eventTicketInfo = [...arr];

    setLoading(true);
    try {

      const response = await post(`${BaseUrl}/event-order-ms/ticket/create-order`, data);
      toast({
        title: "Tickets successfully reserved.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      setOrderConfirmed(response?.body); // Set the state to show the form
    } catch (error) {
      toast({
        title: "Check tickets quantity",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return { onSubmit, loading, orderConfirmed, setOrderConfirmed };
};
